import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/image/LazyImage.tsx
import React from "react";
var LazyImage = (_a) => {
  var _b = _a, { className, src, srcSet, sizes } = _b, props = __objRest(_b, ["className", "src", "srcSet", "sizes"]);
  return /* @__PURE__ */ React.createElement(
    "img",
    __spreadValues({
      className: cn(
        "absolute left-0 top-0 h-full w-full object-cover text-transparent transition-opacity lazyload",
        className
      ),
      "data-src": src,
      "data-srcset": srcSet,
      sizes
    }, props)
  );
};

export {
  LazyImage
};
